import { connect } from 'react-redux';
import { RefundRequestorComponent } from '../../components';
import {
  getRefundData,
  getZendeskData,
  createRefund,
  updateReturnedRefund,
  addComment,
  resetZendeskFields,
  uploadFiles,
  getRefundsCount,
  getTransactions
} from '../../redux/actions/refunds';
import { getAllOperatorData as getOperatorData } from '../../redux/actions/operator';
import { notifyUser } from '../../redux/actions/notification';
import { withRouter } from 'react-router';

const mapStateToProps = state => ({
  refunds: state.refunds.data,
  zendeskData: state.refunds.zendesk.data,
  zendeskDataLoading: state.refunds.zendesk.loading,
  zendeskDataLoaded: state.refunds.zendesk.loaded,
  operators: state.operator.allData,
  loading: state.refunds.loading,
  uploading: state.refunds.uploading,
  refundCount: state.refunds.refundCount,
  transactions: state.refunds.transactions,
  loadingTransactions: state.refunds.loadingTransactions
})

const mapDispatchToProps = {
  getRefundData,
  getZendeskData,
  createRefund,
  updateReturnedRefund,
  addComment,
  getOperatorData,
  notifyUser,
  resetZendeskFields,
  uploadFiles,
  getRefundsCount,
  getTransactions
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RefundRequestorComponent))



// WEBPACK FOOTER //
// ./src/containers/RefundRequestor/RefundRequestor.js